<template>
  <div
    class="c--flex"
    :style="style"
    :class="{pointer : pointer}"
    v-on="$listeners"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Flex',
  props: {
    justify: {
      type: String,
      default: 'start',
    },
    wrap: {
      type: String,
      default: 'nowrap',
    },
    align: {
      type: String,
      default: 'start',
    },
    paddingY: {
      type: String,
      default: '',
    },
    paddingX: {
      type: String,
      default: '',
    },
    direction: {
      type: String,
      default: 'flex-start',
    },
    pointer: {
      type: Boolean,
      default: false,
    },
    inline: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    style() {
      let result = {
        display: this.inline ? 'inline-flex' : 'flex',
        'justify-content': this.justify,
        'flex-wrap': this.wrap,
        'flex-direction': this.direction,
        'align-items': this.align,
      };
      if (this.paddingY !== '') {
        result = {
          ...result,
          paddingTop: this.paddingY,
          paddingBottom: this.paddingY,
        };
      }
      if (this.paddingX !== '') {
        result = {
          ...result,
          paddingLeft: this.paddingX ? this.paddingX : 0,
          paddingRight: this.paddingX ? this.paddingX : 0,
        };
      }
      return result;
    },

  },

};
</script>

<style scoped lang="less">
.c--flex {
  width: 100%;
  box-sizing: border-box;
  &.pointer {
    cursor: pointer;
  }
}
</style>
